import { render } from "./AlertsContent.vue?vue&type=template&id=f639e15c&scoped=true"
import script from "./AlertsContent.vue?vue&type=script&lang=js"
export * from "./AlertsContent.vue?vue&type=script&lang=js"

import "./AlertsContent.vue?vue&type=style&index=0&id=f639e15c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f639e15c"]])

export default __exports__